import React from 'react';
import SVGLoader from './SVGLoader';

const IgnoreIcon = ({ ...rest }) => {
  return (
    <SVGLoader {...rest}>
      <path d="M46.55,78.46l2.37,1.3a1.19,1.19,0,0,0,1.08.43A1.92,1.92,0,0,0,51.08,80l2.37-1.29c12.94-7.55,22.42-12.94,22.42-30.62V30.59a2.07,2.07,0,0,0-1.5-1.94L50.65,20a1.81,1.81,0,0,0-1.51,0L25.42,28.65a2.19,2.19,0,0,0-1.3,1.94V47.84C24.12,65.74,33.61,71.13,46.55,78.46ZM42,45.47a2.14,2.14,0,0,1,3-3l5,5,5-5a2.14,2.14,0,0,1,3,3l-5,5,5,5a2.09,2.09,0,0,1,0,3,2.08,2.08,0,0,1-3,0l-5-5-5,5a2.08,2.08,0,0,1-3,0,2.09,2.09,0,0,1,0-3l5-5Z" />
    </SVGLoader>
  );
};

export default IgnoreIcon;
